module.exports = __webpack_public_path__ + "static/media/facebook.3b637d86.svg";